const emptyMessage = {
    title: false,
    body: false,
    buttons: {
        ok: 'OK'
    },
    closeButton: false,
    submitOnClose: false,
};

const recaptchaSiteKey = _.get(SS, 'vars.Settings.GoogleRecaptcha.site_key', false);

const Task = props => {
    const {
        formData,
        formItems,
        formItemConditions,
        task,
        taskAssignmentId,
        contentItemId,
        eventCode,
        secondaryPeople,
        isModule,
        moduleItemId,
        redirect,
        moduleSettings,
        sequence,
        debug,
    } = props;
    
    const {
        id: taskId = null,
        type: taskType = null,
        title: taskTitle = null,
        description: taskDescription = null,
        button_complete_hide: completeButtonHide = false,
        button_cancel_hide: cancelButtonHide = false,
        is_optional: taskIsOptional = false,
        button_complete_text: completeButtonText = null,
        button_cancel_text: cancelButtonText = null,
        button_skip_text: skipButtonText = null,
        settings: taskSettings = null,
    } = task;

    const showRecaptcha = Boolean(_.get(moduleSettings, 'show_recaptcha') === '1');
    const showNavigation = Boolean(_.get(moduleSettings, 'show_navigation') === '1');

    const formRef = React.useRef(null);
    const [formIsValid, setFormIsValid] = React.useState(true);
    const [loading, setLoading] = React.useState(false);
    const [value, setValue] = React.useState({});
    const [message, setMessage] = React.useState(emptyMessage);
    const [recaptchaErrors, setRecaptchaErrors] = React.useState(false);
    const captcha = React.useRef(null);
    const captchaRef = React.useRef(null);

    const validate = React.useCallback(() => {
        let formIsValid = formRef.current.checkValidity();
        if(taskType === 'File'){
            if(!Boolean(_.size(value.filename))){
                formIsValid = false;
            }
        }

        setFormIsValid(formIsValid);

        if(!formIsValid){
            setMessage({
                title: 'Validation Error',
                body: <span>Please make sure all the fields above have been filled out correctly.</span>,
                buttons: {
                    ok: 'OK'
                },
                closeButton: false,
                submitOnClose: false,
                onSubmit: clearMessage,
            });
        }

        return formIsValid;
    }, [taskType, value]);

    const clearMessage = React.useCallback(() => {
        let scrollStep = -window.scrollY / (500 / 15);
        let scrollInterval = setInterval(() => {
            if (window.scrollY !== 0) {
                window.scrollBy( 0, scrollStep );
            } else {
                clearInterval(scrollInterval);
            }
        },15);

        setMessage(emptyMessage);
    }, []);

    const submit = React.useCallback((action = 'submit') => event => {
        event.preventDefault();

        if (action === 'submit' && !validate()) {
            return;
        }

        setLoading(true);

        let data = {
            task_assignment_id: taskAssignmentId,
            task_id: taskId,
            content_item_id: contentItemId,
            event_code: eventCode,
            ...value,
            _Token: {
                key: SS.csrfToken
            }
        };
        if(taskType === 'Form'){
            _.set(data, 'data', JSON.stringify(value.data));
        }
        if (showRecaptcha) {
            _.set(data, 'g-recaptcha-response', grecaptcha.getResponse(captcha.current));
        }
        if (isModule) {
            _.set(data, 'module_item_id', moduleItemId);
        }
        if(action === 'skip') {
            _.set(data, 'skip', 1);
        }

        let submitUrl = SS.route('Processes', 'Processes', (isModule ? 'submitTaskModule' : 'submitTask'), null);
        if (action === 'cancel') {
            submitUrl = SS.route('Processes', 'Processes', 'cancelTask', null);
        }

        axios({
            method: 'post',
            url: submitUrl,
            data: data,
        })
            .then(response => {
                if(!response.data.success){
                    setFormIsValid(false);
                    setLoading(false);
                    setRecaptchaErrors(response.data.recaptchaErrors);
                    return;
                }
                if (redirect) {
                    window.location = redirect;
                    return;
                }
                if (response.data.response.redirect) {
                    window.location = response.data.response.redirect;
                    return;
                }
                setFormIsValid(true);
                setLoading(false);
                setRecaptchaErrors(false);
                setMessage({
                    title: 'Form submitted',
                    body: <span>Your form was successfully submitted!</span>,
                    buttons: {
                        ok: 'OK'
                    },
                    closeButton: false,
                    submitOnClose: false,
                    onSubmit: clearMessage,
                });
            }).catch( error => {
                if(error.response.data.message){
                    setFormIsValid(false);
                    setLoading(false);
                    setMessage({
                        title: 'Error',
                        body: error.response.data.message,
                        buttons: {
                            ok: 'OK'
                        },
                        closeButton: false,
                        submitOnClose: false,
                        onSubmit: clearMessage,
                    });
                }
            });
    }, [
        formIsValid,
        taskType,
        taskAssignmentId,
        taskId,
        contentItemId,
        eventCode,
        value,
        isModule,
        moduleItemId,
        redirect,
        showRecaptcha
    ]);

    const onChangeValue = React.useCallback((path, value) => {
        setValue(currentValue => {
            let newValue = _.clone(currentValue);
            _.set(newValue, path, value);
            return newValue;
        });
    }, []);

    const onChangeFormValue = React.useCallback(value => {
        let newValue = _.clone(value);
        valueTree(newValue, formItems);
        setValue({'data': newValue});
    }, [formItems]);

    React.useEffect(() => {
        if(taskType === 'Form'){
            valueTree(formData, formItems, true);
            setValue({'data': formData});
        }
    }, [formData, formItems]);

    React.useEffect(() => {
        if(showRecaptcha){
            SSRecaptcha.ready(function(){
                if(!captcha.current){
                    captcha.current = grecaptcha.render(captchaRef.current, {
                        'sitekey': recaptchaSiteKey,
                    });
                }
            }.bind(this));
        }
    }, [showRecaptcha]);

    //useRenderDebug('Task', {props, formIsValid, loading, value, message});

    let TaskClass = eval(`Task${taskType}`);
    let TaskProps = {
        value: value,
        onChange: onChangeValue,
        valid: formIsValid
    };

    if (taskType === 'Form') {
        _.set(TaskProps, 'value', value.data);
        _.set(TaskProps, 'onChange', onChangeFormValue);
        _.set(TaskProps, 'formItems', formItems);
        _.set(TaskProps, 'formItemConditions', formItemConditions);
        _.set(TaskProps, 'showLabelAsPlaceholder', Boolean(_.get(taskSettings, 'show_labels_as_placeholders', '0')));
    }
    if (taskType === 'Note') {
        _.set(TaskProps, 'showSubject', Boolean(_.get(taskSettings, 'show_subject', '0')));
        _.set(TaskProps, 'showImportant', Boolean(_.get(taskSettings, 'show_important', '0')));
    }
    if (taskType === 'Relationship') {
        _.set(TaskProps, 'people', secondaryPeople);
        _.set(TaskProps, 'allowMultiSelection', Boolean(_.get(taskSettings, 'allow_multi_selection', '0')));
        _.set(TaskProps, 'renderOptionsAs', Boolean(_.size(_.get(taskSettings, 'render_options_as'))) ? _.get(taskSettings, 'render_options_as') : 'radio');
        _.set(TaskProps, 'groupOptionsBy', Boolean(_.size(_.get(taskSettings, 'group_options_by'))) ? _.get(taskSettings, 'group_options_by') : null);
        _.set(TaskProps, 'missingGroupValue', Boolean(_.size(_.get(taskSettings, 'missing_group_value'))) ? _.get(taskSettings, 'missing_group_value') : 'Other');
        _.set(TaskProps, 'enableCollapsibleGroups', Boolean(_.get(taskSettings, 'enable_collapsible_groups', '0')));
    }

    let navigationLinks = [];
    if(showNavigation){
        _.each(sequence, sequenceItem => {
            navigationLinks.push(
                <a href={sequenceItem.url} className={`navigation-link ${sequenceItem.selected ? 'selected' : ''}`}>
                    {_.get(sequenceItem, 'ProcessTask.title')}
                </a>
            );
        });
    }

    return (
        <React.Fragment>
            {loading &&
                <div className={'process-task-loading-mask'}>
                    <i className="fa fa-spinner fa-pulse fa-3x fa-fw"/>
                </div>
            }
            {Boolean(_.size(navigationLinks)) &&
                <div className={'process-task-navigation'}>
                    <div className={'navigation-title'}>Task Sequence</div>
                    {navigationLinks}
                </div>
            }
            <div className={`processes-task-inner ${debug ? 'debugging' : ''}`}>
                {Boolean(message.body) &&
                    <CustomAlert {...message}/>
                }
                {taskTitle && <h2 className={'processes-task-title'} dangerouslySetInnerHTML={{__html: taskTitle}}/>}
                {taskDescription && <div className={'processes-task-description'} dangerouslySetInnerHTML={{__html: taskDescription}}/>}
                <form className={`processes-task-body ${!formIsValid ? 'validate' : ''}`} ref={formRef} onSubmit={submit('submit')} noValidate>
                    <TaskClass {...TaskProps}/>
                    {showRecaptcha &&
                        <div ref={captchaRef} className={'g-recaptcha'}/>
                    }
                    {Boolean(showRecaptcha && recaptchaErrors) &&
                        <div className={'g-recaptcha-errors'}>{_.join(recaptchaErrors, '<br/>')}</div>
                    }
                </form>
                <div className="processes-task-buttons">
                    {Boolean(!completeButtonHide && taskType !== 'DocuSign') && <button className={'tpl-button'} onClick={submit('submit')}>{completeButtonText}</button>}
                    {!cancelButtonHide && <button className={'tpl-button'} onClick={submit('cancel')}>{cancelButtonText}</button>}
                    {taskIsOptional && <button className={'tpl-button'} onClick={submit('skip')}>{skipButtonText}</button>}
                </div>
            </div>
        </React.Fragment>
    );
};

Task.propTypes = {
    formData: PropTypes.object,
    formItems: PropTypes.array,
    formItemConditions: PropTypes.object,
    workflow: PropTypes.object,
    task: PropTypes.object,
    taskAssignmentId: PropTypes.number,
    contentItemId: PropTypes.number,
    eventCode: PropTypes.string,
    ssVars: PropTypes.object,
    secondaryPeople: PropTypes.array,
    dashboardUrl: PropTypes.string,
    isModule: PropTypes.bool,
    moduleItemId: PropTypes.number,
    redirect: PropTypes.string,
    showRecaptcha: PropTypes.bool,
    moduleSettings: PropTypes.object,
    sequence: PropTypes.array,
    debug: PropTypes.bool,
};

Task.defaultProps = {
    formData: {},
    formItems: null,
    formItemConditions: {},
    workflow: null,
    task: null,
    taskAssignmentId: null,
    contentItemId: null,
    eventCode: null,
    ssVars: null,
    secondaryPeople: null,
    dashboardUrl: null,
    isModule: false,
    moduleItemId: null,
    redirect: null,
    showRecaptcha: false,
    moduleSettings: null,
    sequence: null,
    debug: false,
};
